module.exports = __webpack_public_path__ + "img/not-found.8c0dbfe0.svg";